import type { View } from '../nav/navModel';

/**
 * NS-1 — where each headline dashboard number drills to, as ONE tested map.
 *
 * NORTH_STAR §0 promises the owner can "drill any number." The KPI tiles were dead `<div>`s (only the
 * inquiries tile carried an `onClick`). This map is the single authority for the drill destination, keyed by
 * the metric's exact label (already its stable React key in DashboardScreen). Two rules it enforces:
 *
 *   1. A tile may only point at a view that ACTUALLY SHOWS that number's detail — verified against source:
 *      revenue/gross/margin/open/below-floor → `deals` (DealsScreen lists them and flags «⚠ زیر حد مجاز»);
 *      owner-net → `close` (CloseScreen is the owner-net breakdown); receivable carry → `cash`
 *      (CashCalendarScreen — aging/cheques); price freshness → `prices`. Drilling a number to a screen that
 *      does not show it would be a worse dead-end than a plain tile.
 *   2. A label ABSENT here is deliberately NOT drillable — overhead-status, cost-coverage, material-inventory
 *      and over-credit have no single unambiguous "detail" view, so they stay plain tiles rather than guess a
 *      destination (guessing is the decorative trap). Those are a later, owner-scoped decision.
 */
export const METRIC_DRILL: Readonly<Record<string, View>> = {
  'پیشنهاد/قرارداد باز': 'deals',
  'درآمد باز': 'deals',
  'سود ناخالص باز': 'deals',
  'حاشیه ناخالص': 'deals',
  'زیر حد حاشیه': 'deals',
  'سود خالص مالک': 'close',
  'هزینهٔ حمل دریافتنی': 'cash',
  'تازگی قیمت': 'prices',
};

/** The view a headline KPI drills to, or `undefined` when it is deliberately not drillable. */
export function metricDrill(label: string): View | undefined {
  return METRIC_DRILL[label];
}
